import { _get , _post, _postNoEncrypt } from '@/utils/http';

export const getwechatConfig = (wxUrl) => {
    var url = '/insurance-web/weixin/js/wxconfig';
    return _postNoEncrypt(url, {
        'url': wxUrl
    });
};

//授权登录
export const wechatLogin = (code) => {
    var url = '/insurance-web/wechatLogin';
    return _post(url, {
        'code': code
    });
};

//openId

export const wechatOpenid = (code) => {
    var url = '/insurance-web/insertOpenid';
    return _post(url, {
        'code': code
    });
};

//UnionId

export const wechatUnionId = (code) => {
    var url = '/insurance-web/insertUnionId';
    return _post(url, {
        'code': code
    });
};


/**
 * 二维码获取产品信息
 *
 */
export const getShareProductInfo = (productCode)=>{
    var url = '/insurance-web/product/getShareProductInfo?productCode='+productCode;
    return _get(url);
};





// WEBPACK FOOTER //
// ./src/api/wechat.js